import { getMyPermissionAccess, PermissionInfo } from '@adornis/abac/policies/SimpleRolePolicy.js';
import { Entity } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { context } from '@adornis/baseql/server/context.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { SmartTeamsPermission } from '../roles-and-permissions.js';

export const getPartnerCompanyFilter = registerQuery({
  type: () => MongoPartnerCompanyFilter,
  operationName: 'getPartnerCompanyFilter',
  resolve: () => {
    return async (gqlFields: BaseQLSelectionSet<MongoPartnerCompanyFilter>) => {
      if (context.serverContext) {
        return new MongoPartnerCompanyFilter({
          hasAccess: true,
          isGlobal: true,
        });
      }
      const permissionInfo = await getMyPermissionAccess(SmartTeamsPermission.CompanyRead)({
        allowedContexts: 1,
        hasAccess: 1,
        isGlobal: 1,
      });

      return new MongoPartnerCompanyFilter({
        ...permissionInfo.toObject(),
      });
    };
  },
  params: [],
});

@Entity()
export class MongoPartnerCompanyFilter extends PermissionInfo {
  static override _class = 'MongoPartnerCompanyFilter';

  parseMongoFilter() {
    if (!this.hasAccess) return { _id: null as any };
    if (this.isGlobal) return {};
    return { _id: { $in: this.allowedContexts } };
  }

  constructor(doc: PartialEntityData<MongoPartnerCompanyFilter>) {
    super(doc);
  }
}
